export default __webpack_public_path__ + "static/media/csharpblue_1.57b55e94.png";